import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import Loader from 'Pods/Shared/Loader'

import Models from './Models/Models'

function ModelsContainer({ isDataFetched, data }) {
  return (
    <div className="card card--flat">
      <div className="dashboard-card dashboard-card--stats">
        <h3>
          <a href="/profile/models">Models</a> <Tooltip
            tooltipClassName="tooltip--medium"
            id="dashboard__stats-models-info"
            content="A short summary of your model data to help you keep track of your assets"
          >
            <Icon type={['far', 'question-circle']} color="grey" notSpaced />
          </Tooltip>
        </h3>
        {!isDataFetched ? (
          <Loader />
        ) : (
          data.length === 0 ? (
            <div className="empty-content u-text-center">
              <p>
                Ooops! Something went wrong
              </p>
            </div>
          ) : (
            <Models data={data} />
          ))}
      </div>
    </div>
  )
}

ModelsContainer.propTypes = {
  isDataFetched: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
}

export default ModelsContainer
